import React from "react";
import packageJson from '../../../../package.json';

import './index.scss';

export const Info = () => {
  return <div className="m-Info">build version: {packageJson.version}</div>;
};